import { createFileRoute } from "@tanstack/react-router";

import { RegisterPage } from "../components/auth/RegisterPage";

/** Search params accepted by `/register` (invite links). */
export interface RegisterSearch {
  invite?: string;
}

/**
 * Invite-gated Dovod-account registration. Production recipients copy
 * the token from the gateway-hosted invite handoff page; the query parameter
 * remains supported for same-origin development and direct in-app navigation.
 */
export const Route = createFileRoute("/register")({
  validateSearch: (search: Record<string, unknown>): RegisterSearch => ({
    invite:
      typeof search.invite === "string" && search.invite.length > 0 ? search.invite : undefined,
  }),
  component: RegisterPage,
});
